import { render } from "./ContractFiguresSelfScreen.vue?vue&type=template&id=39c87d29"
import script from "./ContractFiguresSelfScreen.vue?vue&type=script&lang=js"
export * from "./ContractFiguresSelfScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__